import { MutableRefObject, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import { ReactComponent as CommentPlus } from '../../assets/svg/comment-plus.svg';
import { ReactComponent as Ellipsis } from '../../assets/svg/ellipsis.svg';


const useIsOverflow = (ref: MutableRefObject<HTMLSpanElement | null>, callback?: (v: boolean | null) => void) => {
    const [isOverflow, setIsOverflow] = useState<boolean | null>(null);

    useLayoutEffect(() => {
        const { current } = ref;

        const trigger = (c: HTMLSpanElement) => {
            if (c.offsetWidth === 0) return;
            const hasOverflow = c.scrollWidth > c.clientWidth;

            setIsOverflow(hasOverflow);

            if (callback) callback(hasOverflow);
        };

        if (current) {
            if ('ResizeObserver' in window) {
                new ResizeObserver(() => trigger(current)).observe(current);
            }
            // trigger(current);
        }
    }, [callback, ref]);

    return isOverflow;
};

interface FormEntryCommentProps {
    value?: string,
    editable?: boolean,
    setValue?: (v: string | undefined) => void
}

function FormEntryComment({ value, editable, setValue }: FormEntryCommentProps) {
    const [isFull, setIsFull] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [localValue, setLocalValue] = useState(value);
    const textRef = useRef<HTMLSpanElement | null>(null);

    const [isEllipsisActive, setIsEllipsisActive] = useState(false);

    useIsOverflow(textRef, (isOverflowFromCallback) => {
        if (!isFull) {
            if (isOverflowFromCallback) {
                setIsEllipsisActive(true);
            } else {
                setIsEllipsisActive(false);
            }
        } else {
            setIsEllipsisActive(true);
        }
        // true
    });

    useEffect(() => {
        setIsEllipsisActive(false);
        setIsFull(false);
    }, [value]);

    return (
        <div className={'form__entry-comment' + ((isFull && !isEdit) ? ' _full' : '') + ((value && !isEdit) ? ' _text' : '') + (isEdit ? ' _edit' : '')}>
            <div className="form__entry-comment-body">
                {editable &&
                    <div className="form__entry-comment-menu">
                        <div className="form__entry-comment-menu-icon">
                            <Ellipsis />
                        </div>
                        <div className="form__entry-comment-menu-nav">
                            <span className="form__entry-comment-menu-nav-item _edit" onClick={() => { setLocalValue(value); setIsEdit(true); }} >Изменить</span>
                            <span className="form__entry-comment-menu-nav-item _remove" onClick={() => setValue && setValue(undefined)}>Удалить</span>
                        </div>
                    </div>
                }
                <span ref={textRef} className="form__entry-comment-text">{value}</span>
                {isEllipsisActive &&
                    <span className="form__entry-comment-full" onClick={() => setIsFull((v) => !v)}>{isFull ? 'Скрыть' : 'Показать все'}</span>
                }
            </div>
            {editable &&
                <div className="form__entry-comment-add" onClick={() => setIsEdit(true)}>
                    <CommentPlus />
                </div>
            }
            {isEdit &&
                <div className="form__entry-comment-form">
                    <textarea className="form__input" value={localValue} onChange={(e) => setLocalValue(e.target.value)}></textarea>
                    <div className="form__entry-comment-form-cta">
                        <span className={'btn _min' + ((localValue?.length && value != localValue) ? '' : ' _disabled')} onClick={() => { setValue && setValue(localValue); setIsFull(false); setIsEdit(false); }}>{value ? 'Изменить' : 'Добавить'}</span>
                        <span className="btn _min" onClick={() => setIsEdit(false)}>
                            <Trans>Cancel</Trans>
                        </span>
                    </div>
                </div>
            }
        </div>
    );
}

export default FormEntryComment;